import LogRocket from "logrocket";
import { useEffect } from "react";
import './App.css';
import LandingPage from './screens/LandingPage/LandingPage';

function App() {

    //for log rocket init
    useEffect(() => {
      if (
        process.env.NODE_ENV === "production" &&
        window.location.hostname !== "localhost"
      ) {
        if (process.env.REACT_APP_LOG_ROCKET_KEY) {
          LogRocket.init(process.env.REACT_APP_LOG_ROCKET_KEY);
        }
      }
    }, []);

  return (
    <LandingPage />
  );
}

export default App;
